<template>
  <div class="scriptLibrary-container">
    <div class="operat_row">
      <div class="operat_left">
        <el-input
          size="mini"
          placeholder="请输入搜索内容"
          v-model="paramsObj.keyword"
          clearable
          @clear="getData()"
        >
        </el-input>
        <el-select
          size="mini"
          v-model="paramsObj.oneClassId"
          clearable
          :placeholder="oneOptions.length > 0 ? '请选择' : '无数据'"
          v-loading="loading1"
          @change="getTwoClassData()"
          @clear="twoOptions = []"
        >
          <el-option
            v-for="item in oneOptions"
            :key="item.classId"
            :label="item.className"
            :value="item.classId"
          >
          </el-option>
        </el-select>
        <el-select
          size="mini"
          v-model="paramsObj.twoClassId"
          clearable
          :placeholder="twoOptions.length > 0 ? '请选择' : '无数据'"
          v-loading="loading2"
          @clear="getData()"
          @change="getData()"
        >
          <el-option
            v-for="item in twoOptions"
            :key="item.classId"
            :label="item.className"
            :value="item.classId"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="mini" @click="getData()"
          >搜索</el-button
        >
      </div>
      <div class="operat_right">
        <el-button
          type="primary"
          size="mini"
          @click="handleEditAdd('', 'add')"
          v-if="hasAuth('cjhs')"
          >创建话术</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisiClass = true"
          v-if="hasAuth('glfl')"
          >管理分类</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisiImport = true"
          v-if="hasAuth('daoru')"
          >导入</el-button
        >
      </div>
    </div>

    <el-table
      size="small"
      :data="tableData"
      highlight-current-row
      align="center"
      max-height="700"
      :header-cell-style="{ background: '#F9F9F9' }"
      ref="cusChatTable"
      style="font-size: 13px"
      v-loading="loading"
    >
      <el-table-column type="index" width="50px" />
      <el-table-column prop="title" label="话术标题" width="250px" />
      <el-table-column prop="oneClassName" label="一级分类" width="150px" />
      <el-table-column prop="twoClassName" label="二级分类" width="150px" />
      <el-table-column prop="content" label="话术内容" width="300px">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title=""
            width="800"
            trigger="hover"
            popper-class="workorder-problem-desc"
          >
            <div>{{ scope.row.content }}</div>
            <span slot="reference" class="span_hidden">
              {{ scope.row.content }}
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="useNum" label="引用次数" width="150px" />
      <el-table-column prop="createTime" label="创建时间" width="200px" />
      <el-table-column prop="userName" label="创建人" width="150px" />
      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleEditAdd(scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button @click="handleDelete(scope.row)" type="text" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-bind:childMsg="paramsObj"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- <el-pagination
      @size-change="getData()"
      @current-change="getData()"
      :current-page.sync="paramsObj.pageNum"
      :page-sizes="[20, 50, 100, 200]"
      :page-size.sync="paramsObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    >
    </el-pagination> -->

    <addEditPopup
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :popupConfig="popupConfig"
      @getData="getData()"
    ></addEditPopup>
    <manageClassPopup
      v-if="dialogVisiClass"
      :dialogVisiClass.sync="dialogVisiClass"
      @getData="getData()"
    ></manageClassPopup>
    <importPopup
      v-if="dialogVisiImport"
      :dialogVisiImport.sync="dialogVisiImport"
      @getData="getData()"
    ></importPopup>
  </div>
</template>
<script>
import {
  getOneClass,
  getTwoClass,
  getList,
  deleteScript,
} from "@/api/sciptLibrary/index";
import addEditPopup from "./addEditPopup.vue";
import manageClassPopup from "./manageClassPopup.vue";
import importPopup from "./importPopup.vue";
export default {
  name: "scriptLibrary",
  components: {
    addEditPopup,
    manageClassPopup,
    importPopup,
  },
  data() {
    return {
      dialogVisible: false,

      dialogVisiClass: false,
      dialogVisiImport: false,
      loading: false,
      loading1: false,
      loading2: false,
      oneOptions: [],
      twoOptions: [],
      paramsObj: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
        keyword: "",
        oneClassId: "",
        twoClassId: "",
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      // count: 0,
      tableData: [],
      // tableHeight: 200,
      popupConfig: {
        title: "",
        scriptId: "",
      },
      cfunBu: [],
    };
  },
  mounted() {
    this.getOneClassData();
    // this.$nextTick(function () {
    //   this.tableHeight = window.innerHeight - this.$refs.cusChatTable.$el.offsetTop - 150
    //   // 监听窗口大小变化
    //   let self = this;
    //   window.onresize = function () {
    //     self.tableHeight = window.innerHeight - self.$refs.cusChatTable.$el.offsetTop - 32
    //   }
    // })
  },
  methods: {
    // 权限
    hasAuth(val) {
      if (this.cfunBu.length < 1) {
        return false;
      }

      return this.cfunBu.some((e) => {
        return e == val;
      });
    },
    async getOneClassData() {
      this.paramsObj.oneClassId = "";
      this.loading1 = true;
      let res = await getOneClass(true);
      if (res.error.code == 200 && res.data.length > 0) {
        this.oneOptions = res.data;
        // this.paramsObj.oneClassId = res.data[0].classId
      } else {
        this.oneOptions = [];
      }
      this.loading1 = false;

      if (this.paramsObj.oneClassId) {
        this.getTwoClassData();
      } else {
        this.getData();
      }
    },
    async getTwoClassData() {
      this.paramsObj.twoClassId = "";
      if (this.paramsObj.oneClassId) {
        this.loading2 = true;
        let res = await getTwoClass(this.paramsObj.oneClassId, true);
        if (res.error.code == 200 && res.data.length > 0) {
          this.twoOptions = res.data;
          // this.paramsObj.twoClassId = res.data[0].classId
        } else {
          this.twoOptions = [];
        }
        this.loading2 = false;
      }
      this.getData();
    },
    // 获取数据
    async getData() {
      this.loading = true;
      const requestParams = {
        ...this.paramsObj,
        ...this.formInline,
      }
      let res = await getList(requestParams, true);
      if (res.error.code == 200) {
        console.log(88, res);
        this.tableData = res.data.data;
        this.paramsObj.total = res.data.count;
      } else {
        this.tableData = [];
        this.paramsObj.total = 0;
      }
      this.loading = false;
    },

    handleEditAdd(row, type) {
      if (type == "add") {
        this.popupConfig.title = "创建话术库";
        this.popupConfig.scriptId = "";
      } else {
        this.popupConfig.title = "编辑话术库";
        this.popupConfig.scriptId = row.scriptId;
      }
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该话术, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api();
        })
        .catch(() => {});

      const api = async () => {
        this.loading = true;
        let res = await deleteScript(row.scriptId, true);
        if (res.error.code == 200) {
          this.getData();
          this.$message({
            type: "success",
            message: "删除成功",
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败",
          });
        }
        this.loading = false;
      };
    },
    //分页回调
    callBack(parm) {
     this.formInline.pageNum = parm.currentPage || parm.pageNum ;
      this.formInline.pageSize = parm.pageSize;
      console.log("this.paramsObj.pageSize ++++", this.paramsObj);
      this.getData();
    },
    manageClass() {},
    importData() {},
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "话术库") {
              console.log(885, item);
              setTimeout(() => {
                this.cfunBu = item.cfunBu;
              }, 300);
              // let senBtnAuthority = item.cfunBu
              // let arr = ['kxjbjsc', 'kxz', 'hmbqgl', 'hmhyygl']
              // this.authorityContainer = []
              // arr.forEach(item => {
              //   if (senBtnAuthority.indexOf(item) != -1) {
              //     // 有权限
              //     this.authorityContainer.push(true)
              //   } else {
              //     // 没有权限
              //     this.authorityContainer.push(false)
              //   }
              // })
            }
          });
          console.log("this.authorityContainer", this.authorityContainer);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      console.log(9999, this.$store.state.tagsView.roleAuthrority);
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
};
</script>
<style lang="scss" scoped>
.scriptLibrary-container {
  .operat_row {
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    .operat_left {
      .el-input,
      .el-select {
        width: 200px;
        margin-right: 20px;
      }
    }

    .operat_right {
    }
  }

  .span_hidden {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
